import { render } from "./PersoenlicheDaten.vue?vue&type=template&id=2a2c7226"
import script from "./PersoenlicheDaten.vue?vue&type=script&lang=js"
export * from "./PersoenlicheDaten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__